<template>
  <div class="vision_content">
    <img class="vision_content_img" :src="returnImage()">
  </div>
</template>

<script>
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";

export default {
  name: "VisionLayout",
  mixins: [imageOption,],
  components: {},
  props: {
    infoData: {},
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage() {

      return `${this.infoData.org_url}`;
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>